import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "#1D2939",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.997 1.334a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333zm5.954 3.333H4.043l.42 6.302c.035.537.06.9.101 1.181.04.273.09.413.145.51.134.235.335.423.577.54.102.05.245.09.52.111.282.023.647.023 1.184.023h2.013c.538 0 .902 0 1.185-.023.275-.022.417-.061.519-.11.242-.118.444-.306.577-.54.056-.098.105-.238.145-.51.041-.281.066-.645.102-1.182zm1.336 0h.71a.667.667 0 1 0 0-1.333h-12a.667.667 0 0 0 0 1.333h.71l.427 6.417v.001c.034.503.061.92.111 1.259.052.353.134.676.306.977.266.468.669.844 1.154 1.08.311.15.639.211.995.24.342.026.76.026 1.264.026h2.065c.505 0 .923 0 1.265-.027.355-.028.683-.089.995-.24a2.67 2.67 0 0 0 1.154-1.08c.17-.3.253-.623.305-.976.05-.338.077-.753.11-1.254l.001-.006zM7.33 7.001a.667.667 0 1 0-1.333 0v3.333a.667.667 0 1 0 1.333 0zm2.667 0a.667.667 0 1 0-1.334 0v3.333a.667.667 0 1 0 1.334 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }